export function circleSwirlie(target) {
    let options = {
        root: document.querySelector('#scrollArea'),
        rootMargin: '0px',
        threshold: 1.0
    }

    let callback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
                for (let i=2; i<entry.target.children.length; i++){ 
                    entry.target.children[i].classList.add('poof');
                }
                observer.unobserve(entry.target);
            }
        });
    };

    
    let observer = new IntersectionObserver(callback, options);

    observer.observe(target);

}